export const comunityList = [
  { label: '홈', url: '/' },
  { label: '팔로잉', url: '/' },
  { label: '집들이', url: '/' },
  { label: '노하우', url: '/' },
  { label: '전문가집들이', url: '/' },
  { label: '셀프가이드', url: '/' },
  { label: '질문과 답변', url: '/' },
  { label: '이벤트', url: '/' },
];

export const storeList = [
  { label: '스토어홈', url: '/' },
  { label: '카테고리', url: '/' },
  { label: '베스트', url: '/' },
  { label: '오늘의딜', url: '/' },
  { label: '지정일배송', url: '/' },
  { label: '프리미엄', url: '/' },
  { label: '기획전', url: '/' },
];

export const categoryList = [
  { label: '가구', url: '/' },
  { label: '페브릭', url: '/' },
  { label: '홈데코/조명', url: '/' },
  { label: '가전', url: '/' },
  { label: '수납/정리', url: '/' },
  { label: '생활', url: '/' },
  { label: '주방', url: '/' },
  { label: '생필품', url: '/' },
  { label: 'DIY/공구', url: '/' },
  { label: '반려동물', url: '/' },
  { label: '홈트레이닝', url: '/' },
];

export const usersMenuList = [
  { label: '마이페이지', url: '/' },
  { label: '나의 쇼핑', url: '/' },
  { label: '스크랩북', url: '/' },
  { label: '알림', url: '/' },
  { label: '이벤트', url: '/' },
  { label: '집들이 글쓰기', url: '/' },
  { label: '노하우 글쓰기', url: '/' },
  { label: '상품 리뷰 글쓰기', url: '/' },
  { label: '고객 센터', url: '/' },
];
